import AaSequence from 'molbio/aa-sequences/AaSequence';
import {PolymerTabState} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults} from 'Navigation';

export default class AlphaFoldTabState extends PolymerTabState<AaSequence> {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: '3D Structure',
      closeable: false,
      preferenceKey: 'protein-structure',
    };
  }
}
